import type { BillingStatus } from "../../billing/billingState";
import { getSupabaseClient } from "./supabase";

/** Calls the `billing` function, which talks to Stripe with the server's key. */
const invokeBilling = async <T>(action: "pay" | "portal" | "refresh") => {
  const { data, error } = await getSupabaseClient().functions.invoke<T>(
    `billing/${action}`,
    { method: "POST" },
  );
  if (error) throw error;
  return data as T;
};

export const billingMethods = {
  /** The Stripe page that settles the subscription: invoice to pay or payment link. */
  async getBillingPaymentUrl(): Promise<string> {
    return (await invokeBilling<{ url: string }>("pay")).url;
  },
  /** Stripe's customer portal: card, invoices, cancellation (administrators). */
  async getBillingPortalUrl(): Promise<string> {
    return (await invokeBilling<{ url: string }>("portal")).url;
  },
  async refreshBilling(): Promise<BillingStatus> {
    return invokeBilling<BillingStatus>("refresh");
  },
};
